import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { LocationEnvironmentApi } from '../../../../../../../../core/api/location-environment/location-environment.api';
import { LocationSectorApi } from '../../../../../../../../core/api/location-sectors/location-sectors.api';
import { ArchiveEnvironmentDialogService } from '../../../../../../../../core/components/archive-environment-dialog/archive-environment-dialog.service';
import { ActionTypeEnum } from '../../../../../../../../core/components/fc-tree-view/fc-tree.types';
import { fetchAllInBatches } from '../../../../../../../../core/utils/fetch-all-in-batches';
import { LinkEquipmentDialogService } from '../../../../../dialog-link-equipment/dialog-link-equipment.service';
import { DialogLocationEnvironmentComponent } from '../../../../../dialog-location-environment/dialog-location-environment.component';
import { EquipmentLinkService } from '../equipment/equipment.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../core/api/location-environment/location-environment.api";
import * as i2 from "../../../../../../../../core/api/location-sectors/location-sectors.api";
import * as i3 from "@ngx-translate/core";
import * as i4 from "@angular/material/dialog";
import * as i5 from "../equipment/equipment.service";
import * as i6 from "../../../../../../../../core/components/archive-environment-dialog/archive-environment-dialog.service";
import * as i7 from "../../../../../dialog-link-equipment/dialog-link-equipment.service";
var LocationLinkEnvironmentService = /** @class */ (function () {
    function LocationLinkEnvironmentService(locationEnvironmentApi, locationSectorApi, translateService, matDialog, equipmentLinkService, archiveEnvironmentDialogService, linkEquipmentDialogService) {
        this.locationEnvironmentApi = locationEnvironmentApi;
        this.locationSectorApi = locationSectorApi;
        this.translateService = translateService;
        this.matDialog = matDialog;
        this.equipmentLinkService = equipmentLinkService;
        this.archiveEnvironmentDialogService = archiveEnvironmentDialogService;
        this.linkEquipmentDialogService = linkEquipmentDialogService;
    }
    LocationLinkEnvironmentService.prototype.searchLocationEnvironments = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, fetchAllInBatches(this.locationEnvironmentApi, params)];
            });
        });
    };
    LocationLinkEnvironmentService.prototype.formatEnvironments = function (environments, parent) {
        var e_1, _a;
        var formattedEnvironments = [];
        try {
            for (var environments_1 = tslib_1.__values(environments), environments_1_1 = environments_1.next(); !environments_1_1.done; environments_1_1 = environments_1.next()) {
                var environment = environments_1_1.value;
                var formattedEnvironment = {
                    id: environment.id,
                    parent: parent,
                    text: environment.name,
                    description: environment.description,
                    searchTerm: [environment.name, environment.description].filter(Boolean).join(' ').toLowerCase(),
                    archived: environment.archived,
                    archivedText: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVED'),
                    icon: 'environment',
                    metadata: 'environment',
                    action: {
                        type: ActionTypeEnum.menu,
                        buttons: this.environmentsButtons(environment)
                    }
                };
                formattedEnvironment.children = this.equipmentLinkService.formatEquipments(environment.equipments, formattedEnvironment);
                formattedEnvironments.push(formattedEnvironment);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (environments_1_1 && !environments_1_1.done && (_a = environments_1.return)) _a.call(environments_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return formattedEnvironments;
    };
    LocationLinkEnvironmentService.prototype.environmentsButtons = function (locationEnvironment) {
        var _this = this;
        return [
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.EDIT_ENVIRONMENT'),
                icon: 'edit',
                color: '#676767',
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openEditLocationEnvironmentDialog({ locationEnvironmentId: locationEnvironment.id })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.LINK_EQUIPMENT'),
                icon: 'equipment',
                color: '#676767',
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openLinkEquipmentDialog({
                                    locationEnvironment: locationEnvironment
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
            {
                text: locationEnvironment.archived ? this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.UNARCHIVE_ENVIRONMENT') : this.translateService.instant('LOCATIONS.DIALOG.TABS.TAB_LINKS.ARCHIVE_ENVIRONMENT'),
                icon: locationEnvironment.archived ? 'unarchive_outline' : 'archive_outline',
                color: '#676767',
                action: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.openArchiveOrUnarchiveLocationEnvironmentDialog({
                                    locationEnvironment: locationEnvironment
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }
            },
        ];
    };
    LocationLinkEnvironmentService.prototype.openLocationEnvironmentDialog = function (_a) {
        var location = _a.location, locationSectorId = _a.locationSectorId, locationEnvironmentId = _a.locationEnvironmentId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                if (locationEnvironmentId) {
                    return [2 /*return*/, this.openEditLocationEnvironmentDialog({ locationEnvironmentId: locationEnvironmentId })];
                }
                else {
                    return [2 /*return*/, this.openCreateLocationEnvironmentDialog({ location: location, locationSectorId: locationSectorId })];
                }
                return [2 /*return*/];
            });
        });
    };
    LocationLinkEnvironmentService.prototype.openCreateLocationEnvironmentDialog = function (_a) {
        var location = _a.location, locationSectorId = _a.locationSectorId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationEnvironment, _b, _c, result;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = {
                            id: null,
                            name: null,
                            description: null,
                            qrCode: null,
                            location: location
                        };
                        if (!locationSectorId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.locationSectorApi.get(locationSectorId)];
                    case 1:
                        _c = _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _c = null;
                        _d.label = 3;
                    case 3:
                        locationEnvironment = (_b.locationSector = _c,
                            _b);
                        return [4 /*yield*/, this.matDialog
                                .open(DialogLocationEnvironmentComponent, {
                                panelClass: 'dialog-location-environment',
                                data: {
                                    locationEnvironment: locationEnvironment
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 4:
                        result = _d.sent();
                        if (result && result.reload) {
                            window.emitEvent('location-links::reload-tree-view');
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkEnvironmentService.prototype.openEditLocationEnvironmentDialog = function (_a) {
        var locationEnvironmentId = _a.locationEnvironmentId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var locationEnvironment, result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.locationEnvironmentApi.get(locationEnvironmentId)];
                    case 1:
                        locationEnvironment = _b.sent();
                        locationEnvironment.location = locationEnvironment.locationSector.location;
                        return [4 /*yield*/, this.matDialog
                                .open(DialogLocationEnvironmentComponent, {
                                panelClass: 'dialog-location-environment',
                                data: {
                                    locationEnvironment: locationEnvironment
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        result = _b.sent();
                        if (result && result.reload) {
                            window.emitEvent('location-links::reload-tree-view');
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkEnvironmentService.prototype.openArchiveOrUnarchiveLocationEnvironmentDialog = function (_a) {
        var locationEnvironment = _a.locationEnvironment;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.archiveEnvironmentDialogService.open({
                            sectorId: locationEnvironment.id,
                            archived: locationEnvironment.archived,
                            name: locationEnvironment.name
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.reload) {
                            return [2 /*return*/];
                        }
                        window.emitEvent('location-links::reload-tree-view');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkEnvironmentService.prototype.openLinkEquipmentDialog = function (_a) {
        var locationEnvironment = _a.locationEnvironment;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.linkEquipmentDialogService.open({
                            locationId: locationEnvironment.locationSector.location.id,
                            locationSectorId: locationEnvironment.locationSector.id,
                            locationEnvironmentId: locationEnvironment.id,
                        })];
                    case 1:
                        result = _b.sent();
                        if (!result || !result.reload) {
                            return [2 /*return*/];
                        }
                        window.emitEvent('location-links::reload-tree-view');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocationLinkEnvironmentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationLinkEnvironmentService_Factory() { return new LocationLinkEnvironmentService(i0.ɵɵinject(i1.LocationEnvironmentApi), i0.ɵɵinject(i2.LocationSectorApi), i0.ɵɵinject(i3.TranslateService), i0.ɵɵinject(i4.MatDialog), i0.ɵɵinject(i5.EquipmentLinkService), i0.ɵɵinject(i6.ArchiveEnvironmentDialogService), i0.ɵɵinject(i7.LinkEquipmentDialogService)); }, token: LocationLinkEnvironmentService, providedIn: "root" });
    return LocationLinkEnvironmentService;
}());
export { LocationLinkEnvironmentService };
